import Bowser from 'bowser'
const browserInfo = Bowser.parse(window.navigator.userAgent)
const browserName = browserInfo
  ? `${browserInfo.browser.name} ${browserInfo.browser.version?.split('.')[0]} on ${browserInfo.os.name} ${browserInfo.os.version}`
  : null

export const AWS_COGNITO_DOMAIN = import.meta.env.VITE_AWS_COGNITO_DOMAIN
export const AWS_CLIENT_ID = import.meta.env.VITE_AWS_CLIENT_ID
export const AWS_REDIRECT_URI = import.meta.env.VITE_AWS_REDIRECT_URI
export const AWS_API_URL = import.meta.env.VITE_AWS_API_URL

export const AWS_REFRESH_TOKEN_INTERVAL = 30 * 60 * 1000 // 30 minutes
export const AWS_HOSTED_UI_URL_APPLE = `${AWS_COGNITO_DOMAIN}/authorize?identity_provider=SignInWithApple&response_type=code&client_id=${AWS_CLIENT_ID}&redirect_uri=${AWS_REDIRECT_URI}`
export const AWS_HOSTED_UI_URL_GOOGLE = `${AWS_COGNITO_DOMAIN}/authorize?identity_provider=Google&response_type=code&client_id=${AWS_CLIENT_ID}&redirect_uri=${AWS_REDIRECT_URI}`

export const __DEV__ = process.env.NODE_ENV === 'development'
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'development'
export const IS_MOBILE_APP = window.IS_MOBILE_APP === true
export const DEVICE_NAME = IS_MOBILE_APP
  ? window.DEVICE_NAME || 'Unknown Mobile Device'
  : browserName || 'Unknown Device'

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || ''

// Fuzzy App Store URL
export const APP_STORE_MOBILE_URL = 'https://apps.apple.com/us/app/fuzzy/id6740005108'

// CSV Template URLs
export const MEMBERS_CSV_TEMPLATE = 'https://docs.google.com/spreadsheets/d/1eEjjDaDxNSMrR6vf9F7mJoFV6FMEFm1HVLKgghwXsJ8/edit?usp=sharing'
export const INDIVIDUALS_CSV_TEMPLATE = 'https://docs.google.com/spreadsheets/d/1JTZWJiw4akzrkItoXHRfKBVKRS-Yu--nrsc5COU4XYk/edit?usp=sharing'
export const INNER_CIRCLE_CSV_TEMPLATE = 'https://docs.google.com/spreadsheets/d/1v2ozNRS5AgtSJwhwE_TaPxIGqzcJnBgjovKaeiqrN4o/edit?usp=sharing'

export const MAX_HEADSHOTS_PER_INDIVIDUAL = 3
export const MAX_ALIASES_PER_INDIVIDUAL = 5

export const MAX_TIME_IDLE_IN_MS = 30 * 60 * 1000 // 30 minutes
